var render = function render(){var _vm=this,_c=_vm._self._c;return _c('embed',{staticClass:"container-fluid",attrs:{"height":"600px","src":_vm.pfdURI}})
}
var staticRenderFns = []

export { render, staticRenderFns }